/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '../../../../../../../SharedModules/Table/TableGridWithFeatures';
import EndDate from '../../../../../../Maintain/group/Components/endDate';
import CMSDrugURATextFieldComponent from './CMSDrugURATextFieldComponent';
import ViewHistoryComponent from '../../../../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { dateFormatForDatePicker } from '../../../../../../../SharedModules/CommonConstants/commonConstants';
import { autoFormateDate } from '../../../../../../../SharedModules/utilities/utilities';
import { validDate } from '../../../../../../../SharedModules/CommonUtilities/commonUtilities';

const CMSDrugURATableComponent = ({
  tableData,
  tableHead,
  setDisableSaveAndCancel,
  hasAccess,
  setErrorMessage,
  errorMessage,
  isEnablebyRole,
}) => {
  const [fullScreenView, setFullScreenView] = useState(false);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);

  const validateBtnDisable = (props) => {
    const newURA = props.data?.newUnitRebateAmt;
    const newTermDt = props.data?.newTerminationDt;

    if ((!newURA || newURA === '') && (!newTermDt || newTermDt === '')) {
      setDisableSaveAndCancel(true);
      if (!errorMessage.includes('Please Enter New URA.')) {
        setErrorMessage((prev) => [...prev, 'Please Enter New URA.']);
      }
    } else {
      setDisableSaveAndCancel(false);
      setErrorMessage((prev) =>
        prev.filter((err) => err !== 'Please Enter New URA.')
      );
    }
  };

  const handleViewHistory = () => {
    setShowViewHistory(true);
    setKeyValue({});
  };

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
  };

  return (
    <div className="table-container fourRecords mt-3 no-border">
      <Grid
        gridHeight={fullScreenView ? '100vh' : 150}
        rowData={tableData}
        defaultCol={{ editable: false, filter: false }}
        columnDefs={tableHead}
        data-testid="onEditingStopped"
        enterMovesDown
        suppressCellFocus
        onCellFocused={onCellFocused}
        singleClickEdit={false}
        navigateToNextCell={navigateToNextCell}
        // tabToNextCell={tabToNextCell}
        // exportFile
        fileName="CMS_DRUG_URA"
        // handleViewHistory={handleViewHistory}
        frameworkComponents={{
          textFieldComponent: (props) => (
            <CMSDrugURATextFieldComponent
              hasAccess={hasAccess}
              {...props}
              validateBtnDisable={validateBtnDisable}
              setErrorMessage={setErrorMessage}
              errorMessage={errorMessage}
              isEnablebyRole={isEnablebyRole}
            />
          ),
          terminationDtComponent: (props) => {
            return (
              // <EndDate
              //   ndcEndDate
              //   {...props}
              //   handleBlur={(props) => {
              //     if (
              //       props.data.newUnitRebateAmt === null &&
              //       props.data.newTerminationDt == null
              //     ) {
              //       setDisableSaveAndCancel(true);
              //     } else {
              //       setDisableSaveAndCancel(false);
              //     }
              //   }}
              // />
              <div className="fullWidth w-100  tbl-manufacturer-inner">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    id={`${props.column.colId}_${props.rowIndex}`}
                    data-testid="termination-date"
                    label={false}
                    mask="__/__/____"
                    InputLabelProps={{ shrink: true }}
                    format={dateFormatForDatePicker}
                    inputFormat={dateFormatForDatePicker}
                    KeyboardButtonProps={{ 'aria-label': 'termination date' }}
                    InputProps={{
                      readOnly: isEnablebyRole,
                      autoFill: isEnablebyRole,
                    }}
                    placeholder="mm/dd/yyyy"
                    value={props.value || null}
                    onChange={(e) => {
                      props.node.setDataValue(props.column.colId, e);
                    }}
                    onBlur={(e) => {
                      const value = e.target.value.replace(/\_/g, '');
                      if (new Date(value) != 'Invalid Date')
                        props.node.setDataValue(
                          props.column.colId,
                          autoFormateDate(value)
                        );
                      if (
                        !props.data.newUnitRebateAmt &&
                        !props.data.newTerminationDt
                      ) {
                        setDisableSaveAndCancel(true);
                      } else {
                        setDisableSaveAndCancel(false);
                      }
                    }}
                    onKeyDown={async (e) => {
                      if (e.keyCode == 67) {
                        // copy date
                        await window.navigator?.clipboard.writeText(
                          e?.target?.value
                        );
                      }
                    }}
                    helperText={null}
                    error={null}
                  />
                </MuiPickersUtilsProvider>
              </div>
            );
          },
        }}
      />
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="CMS_UROA"
          keyValue={keyValue}
        />
      )}
    </div>
  );
};

export default CMSDrugURATableComponent;
